import React, {useContext, useCallback} from "react";

import Button from "./Button.jsx";

export default ({item, className, onChange, busy, min = 0}) => {

  const handleChange = useCallback((qty) => {
    if(typeof onChange == "function") onChange(item.key, Math.max(min, qty));
  }, [item, min]);

  console.log(item.quantity == min);

  return <div>
            <div className={`h-stack justify-center ${className || ''} inline-quantity-selector`}>
              <Button onClick={()=> handleChange(item.quantity - 1)} disabled={busy || item.quantity == min}>-</Button>
              <input class="quantity-input" type="text" is="quantity-input" inputmode="numeric" aria-label="Change quantity" defaultValue={item.quantity} onBlur={(event)=>{handleChange(event.currentTarget.value)}}/>
              <Button onClick={()=> handleChange(item.quantity + 1)} disabled={busy}>+</Button>
            </div>
            <div class="pill-loader_container">
              <pill-loader class="pill-loader" aria-busy={busy}></pill-loader>
            </div>
          </div>;
}
